import React from 'react'
import AthleteSafetyRVP from '../components/AthleteSafetyRVP/AthleteSafetyRVP'
import ResourceLinkNav from '../components/shared/ResourceLinkNav/ResourceLinkNav'
import AdminView from '../components/shared/AdminView'
function AthleteSafetyRVPPage() {
  return (
    <ResourceLinkNav>
      <AdminView/>
      <AthleteSafetyRVP />
    </ResourceLinkNav>
  )
}

export default AthleteSafetyRVPPage